import { MARQUEE_ITEMS } from "@/constants/hotelData";

const Separator = () => (
  <svg className="mx-8 h-3 w-3 shrink-0 text-gold" viewBox="0 0 10 10" aria-hidden="true">
    <rect x="2" y="2" width="6" height="6" transform="rotate(45 5 5)" fill="currentColor" />
  </svg>
);

const Row = ({ hidden = false }) => (
  <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item, i) => (
      <div key={i} className="flex items-center">
        <span className="whitespace-nowrap font-serif text-2xl italic text-gold/90 sm:text-3xl">
          {item}
        </span>
        <Separator />
      </div>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section className="relative overflow-hidden border-y border-gold/15 bg-[#0f241b] py-6">
      <div className="marquee-track flex w-max">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
